import { render, staticRenderFns } from "./CampaignPerformanceDialog.vue?vue&type=template&id=39b0ad3e&scoped=true"
import script from "./CampaignPerformanceDialog.vue?vue&type=script&lang=js"
export * from "./CampaignPerformanceDialog.vue?vue&type=script&lang=js"
import style0 from "./CampaignPerformanceDialog.vue?vue&type=style&index=0&id=39b0ad3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0ad3e",
  null
  
)

export default component.exports